import {
    ASSETS_FETCH_ERROR,
    ASSETS_FETCH_IN_PROGRESS,
    ASSETS_FETCH_SUCCESS,
    BULK_BURN_ADDRESS_SET,
    BULK_BURN_DIALOG_HIDE,
    BULK_BURN_DIALOG_SHOW,
    BULK_DE_LIST_DIALOG_HIDE,
    BULK_DE_LIST_DIALOG_SHOW,
    BULK_DELETE_DIALOG_HIDE,
    BULK_DELETE_DIALOG_SHOW,
    BULK_EDIT_HIDE,
    BULK_EDIT_LIST_SET,
    BULK_EDIT_SHOW,
    BULK_LIST_DIALOG_HIDE,
    BULK_LIST_DIALOG_SHOW,
    BULK_TRANSFER_ADDRESS_SET,
    BULK_TRANSFER_DIALOG_HIDE,
    BULK_TRANSFER_DIALOG_SHOW,
    BURN_NFT_SET,
    CONFIRM_BULK_LIST_DIALOG_HIDE,
    CONFIRM_BULK_LIST_DIALOG_SHOW,
    DOWNLOAD_NON_MINTED_ASSETS_ERROR,
    DOWNLOAD_NON_MINTED_ASSETS_IN_PROGRESS,
    DOWNLOAD_NON_MINTED_ASSETS_SUCCESS,
    LIBRARY_TAB_VALUE_SET,
    LIBRARY_SUB_TAB_VALUE_SET,
    LIST_QUICK_VIEW_HIDE,
    LIST_QUICK_VIEW_SHOW,
    MENU_ACTION_DIALOG_HIDE,
    MENU_ACTION_DIALOG_SHOW,
    MENU_POPOVER_HIDE,
    MENU_POPOVER_SHOW,
    NON_MINTED_EXPORT_POPOVER_HIDE,
    NON_MINTED_EXPORT_POPOVER_SHOW,
    WINDOW_RESIZE_SET,
} from '../constants/library';
import Axios from 'axios';
import { DOWNLOAD_NON_MINTED_ASSETS_URL, urlFetchAssets } from '../constants/url';
import { handleErrorMessage } from '../utils/errorMessages';

export const setWindowResize = (value) => {
    return {
        type: WINDOW_RESIZE_SET,
        value,
    };
};

export const setLibraryTabValue = (value) => {
    return {
        type: LIBRARY_TAB_VALUE_SET,
        value,
    };
};

export const setLibrarySubTabValue = (value) => {
    return {
        type: LIBRARY_SUB_TAB_VALUE_SET,
        value,
    };
};

export const showMenuPopover = (event, value, list) => {
    return {
        type: MENU_POPOVER_SHOW,
        anchorEl: event.currentTarget,
        value,
        list,
    };
};

export const hideMenuPopover = () => {
    return {
        type: MENU_POPOVER_HIDE,
    };
};

export const showListQuickView = (value, list) => {
    return {
        type: LIST_QUICK_VIEW_SHOW,
        value,
        list,
    };
};

export const hideListQuickView = () => {
    return {
        type: LIST_QUICK_VIEW_HIDE,
    };
};

export const showMenuActionDialog = (value) => {
    return {
        type: MENU_ACTION_DIALOG_SHOW,
        value,
    };
};

export const hideMenuActionDialog = () => {
    return {
        type: MENU_ACTION_DIALOG_HIDE,
    };
};

export const setBurnNFT = (value) => {
    return {
        type: BURN_NFT_SET,
        value,
    };
};

export const showNonMintedExportPopover = (event) => {
    return {
        type: NON_MINTED_EXPORT_POPOVER_SHOW,
        anchorEl: event.currentTarget,
    };
};

export const hideNonMintedExportPopover = () => {
    return {
        type: NON_MINTED_EXPORT_POPOVER_HIDE,
    };
};

const fetchAssetsInProgress = () => {
    return {
        type: ASSETS_FETCH_IN_PROGRESS,
    };
};

const fetchAssetsSuccess = (value, skip, limit, total) => {
    return {
        type: ASSETS_FETCH_SUCCESS,
        value,
        skip,
        limit,
        total,
    };
};

const fetchAssetsError = (message) => {
    return {
        type: ASSETS_FETCH_ERROR,
        message,
        variant: 'error',
    };
};

export const fetchAssets = (skip, limit, cb) => (dispatch) => {
    dispatch(fetchAssetsInProgress());

    const url = urlFetchAssets(skip, limit);
    Axios.get(url, {
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(fetchAssetsSuccess(res.data && res.data.result && res.data.result.list,
                skip, limit, res.data && res.data.result && res.data.result.count));
            if (cb) {
                cb(res.data && res.data.result && res.data.result.list, res.data && res.data.result && res.data.result.count);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(fetchAssetsError(message));

            if (cb) {
                cb(null);
            }
        });
};

const downloadNonMintedAssetsInProgress = () => {
    return {
        type: DOWNLOAD_NON_MINTED_ASSETS_IN_PROGRESS,
    };
};

const downloadNonMintedAssetsSuccess = (value) => {
    return {
        type: DOWNLOAD_NON_MINTED_ASSETS_SUCCESS,
        value,
    };
};

const downloadNonMintedAssetsError = (message) => {
    return {
        type: DOWNLOAD_NON_MINTED_ASSETS_ERROR,
        message,
    };
};

export const fetchDownloadNonMintedAssets = (format, cb) => (dispatch) => {
    dispatch(downloadNonMintedAssetsInProgress());

    const url = DOWNLOAD_NON_MINTED_ASSETS_URL(format);
    Axios.get(url, {
        responseType: 'blob',
        headers: {
            Accept: 'application/json, text/plain, */*',
            Authorization: 'Bearer ' + localStorage.getItem('acToken_of_studio'),
        },
    })
        .then((res) => {
            dispatch(downloadNonMintedAssetsSuccess(res.data));
            if (cb) {
                cb(res.data);
            }
        })
        .catch((error) => {
            const message = handleErrorMessage(error);
            dispatch(downloadNonMintedAssetsError(message));

            if (cb) {
                cb(null);
            }
        });
};

export const showBulkEdit = (from) => {
    return {
        type: BULK_EDIT_SHOW,
        from,
    };
};

export const hideBulkEdit = () => {
    return {
        type: BULK_EDIT_HIDE,
    };
};

export const setBulkEditList = (value, from) => {
    return {
        type: BULK_EDIT_LIST_SET,
        value,
        from,
    };
};

export const showBulkListDialog = () => {
    return {
        type: BULK_LIST_DIALOG_SHOW,
    };
};

export const hideBulkListDialog = () => {
    return {
        type: BULK_LIST_DIALOG_HIDE,
    };
};

export const showConfirmBulkListDialog = () => {
    return {
        type: CONFIRM_BULK_LIST_DIALOG_SHOW,
    };
};

export const hideConfirmBulkListDialog = () => {
    return {
        type: CONFIRM_BULK_LIST_DIALOG_HIDE,
    };
};

export const showBulkDeListDialog = () => {
    return {
        type: BULK_DE_LIST_DIALOG_SHOW,
    };
};

export const hideBulkDeListDialog = () => {
    return {
        type: BULK_DE_LIST_DIALOG_HIDE,
    };
};

export const showBulkTransferDialog = () => {
    return {
        type: BULK_TRANSFER_DIALOG_SHOW,
    };
};

export const hideBulkTransferDialog = () => {
    return {
        type: BULK_TRANSFER_DIALOG_HIDE,
    };
};

export const setBulkTransferAddress = (value) => {
    return {
        type: BULK_TRANSFER_ADDRESS_SET,
        value,
    };
};

export const showBulkBurnDialog = () => {
    return {
        type: BULK_BURN_DIALOG_SHOW,
    };
};

export const hideBulkBurnDialog = () => {
    return {
        type: BULK_BURN_DIALOG_HIDE,
    };
};

export const setBulkBurnAddress = (value) => {
    return {
        type: BULK_BURN_ADDRESS_SET,
        value,
    };
};

export const showBulkDeleteDialog = () => {
    return {
        type: BULK_DELETE_DIALOG_SHOW,
    };
};

export const hideBulkDeleteDialog = () => {
    return {
        type: BULK_DELETE_DIALOG_HIDE,
    };
};
